/**
 * Mirrors `demanda/shared/schemas/medchron.py` MedVisitDetail field validators
 * so the UI can detect "no-op" edits before calling PUT (server returns 400 otherwise).
 */
export function normalizeVisitDetailCategory(value: string): string {
  let v = value.trim();
  v = v.replace(/[^a-zA-Z0-9-]/g, "-");
  v = v.replace(/-+/g, "-");
  v = v.replace(/^-+/, "").replace(/-+$/, "");
  return v.toLowerCase();
}

export function trimVisitDetails(value: string): string {
  return value.trim();
}

/** True when draft category + details match stored values after the same normalization the API applies. */
export function areVisitDetailEditsSemanticallyNoop(
  storedCategory: string,
  storedDetails: string,
  draftCategory: string,
  draftDetails: string
): boolean {
  return (
    normalizeVisitDetailCategory(storedCategory) === normalizeVisitDetailCategory(draftCategory) &&
    trimVisitDetails(storedDetails) === trimVisitDetails(draftDetails)
  );
}
